import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/browser';


export const DEFAULT_LOCALE = 'en';

interface Module {
  default?: Record<string,string>
}

async function loadLocaleData( locale: string, isRetry?: boolean ) : Promise<Module> {
  try {
    const normalizedLocale = locale.toLocaleLowerCase();
    switch( normalizedLocale ) {
      case 'fr-ca':
        return await import('./locales/compiled/fr_CA.json');
      case 'fr':
        return await import('./locales/compiled/fr.json');
      case 'es':
        return await import('./locales/compiled/es.json');
      default:
        return await import('./locales/compiled/en.json');
    }
  } catch(error) {
    if( isRetry ) {
      console.warn && console.warn(`Failed to load translation for locale '${locale}'`);
      Sentry.captureException(error);
      return {}; // Just in case something goes wrong, this will ensure we render w/ the English defaults
    }
    else {
      console.warn && console.warn(`Retrying translation load for locale '${locale}'`);
      Sentry.captureMessage(`Retrying translation load for locale '${locale}'`);
      return await loadLocaleData(locale, true);
    }
  }
}

export function useLocaleMessages( locale: string ) {
  const [messages,setMessages] = useState<object>();

  useEffect( () => {
    if( locale ) {
      loadLocaleData(locale).then( setMessages );
    }
  }, [locale]);

  return messages;
}

